import component from './zh-CN/component';
import constants from './zh-CN/constants';
import imm0008 from './zh-CN/form/imm0008';
import imm5406 from './zh-CN/form/imm5406';
import imm5562 from './zh-CN/form/imm5562';
import imm5669 from './zh-CN/form/imm5669';
import globalHeader from './zh-CN/globalHeader';
import menu from './zh-CN/menu';
import pages from './zh-CN/pages';
import pwa from './zh-CN/pwa';
import settingDrawer from './zh-CN/settingDrawer';
import settings from './zh-CN/settings';

export default {
  'navBar.lang': '语言',
  'layout.user.link.help': '帮助',
  'layout.user.link.privacy': '隐私',
  'layout.user.link.terms': '条款',
  'app.preview.down.block': '下载此页面到本地项目',
  'app.welcome.link.fetch-blocks': '获取全部区块',
  'app.welcome.link.block-list': '基于 block 开发，快速构建标准页面',
  ...pages,
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...constants,
  ...imm0008,
  ...imm5406,
  ...imm5562,
  ...imm5669,
};
